<template lang="pug">
w-input.f-integer( 
  v-bind=`{ value, label, required }`
  ref='input'
  type='number'
  @input='input'
)
</template>

<script lang="js">
import WInput, { mixin } from '@/widgets/w-input'

export default {
  name: 'IntegerField',
  mixins: [ mixin ],
  components: { WInput },
  props: {
    label: {
      type: String,
      default: 'Integer',
    },
    value: {
      type: Number,
      default: 0
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.f-username {

}
</style>
